import styled from 'styled-components';
import { Nav } from 'react-bootstrap';
import { colorAccent, colorText, colorHover, colorBorder } from '../theme/palette';
export const TabsWrap = styled.div`
  text-align: left;
  min-width: min-content;
`;
export const NavLink = styled(Nav.Link)`
  padding: 10px 20px;
  margin-right: 0px;
  transition: background-color 0.3s;
  cursor: pointer;
  color: ${colorText};

  &:hover, &:focus, &:active {
    outline: none;
    background-color: ${colorHover} !important;
    border-color: ${colorHover} !important;
    border-bottom-color: ${colorBorder} !important;
    color: ${colorAccent};
  }

  &.active, &.active:focus,
  &.active:hover {
    background-color: transparent !important;
    border-color: ${colorBorder} !important;
    border-bottom-color: white !important;
    color: ${colorAccent} !important;
  }
`; // Componente NavLink customizado que aceita a prop active

export const CustomNavLink = ({
  active,
  children,
  ...props
}) => <NavLink className={active ? 'active' : ''} {...props}>
    {children}
  </NavLink>;
export const NavItem = styled(Nav.Item)`
  &.disabled ${NavLink} {
    color: #999999;
  }
`;
export const Tabs = styled.div`
  .tab-pane {
    padding-top: 15px;
    
    p:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
`;
export const BorderedTopTabs = styled(Tabs)`
  ${NavLink} {
    border-top: 2px solid transparent !important;
    border-radius: 0;
  }

  ${NavLink}.active {
    &, &:focus, &:hover {
      border-radius: 0;
      border-top: 2px solid ${colorAccent} !important;
    }
  }
`;
export const BorderedBottomTabs = styled(Tabs)`
  ${NavLink} {
    border-color: transparent !important;
    border-bottom: 1px solid transparent !important;
    padding-bottom: 11px;
  }

  ${NavLink}.active {
    &, &:focus, &:hover {
      border-radius: 0;
      border-color: transparent !important;
      border-bottom: 2px solid ${colorAccent} !important;
      padding-bottom: 10px;
    }
  }
`;
export const JustifyTabs = styled(Tabs)`
  .nav-tabs {
    display: flex;
    flex-wrap: nowrap;

    ${NavItem} {
      width: 100%;

      a {
        text-align: center;
      }
    }
  }
`;
export const VerticalTabs = styled(Tabs)`
  ${TabsWrap} {
    display: flex;
  }

  .nav-tabs {
    border-bottom: none;
    width: 90px;
    height: 100%;
    flex-wrap: wrap;

    ${NavItem} {
      margin-top: 0;
      margin-bottom: 0;
      width: 100%;

      ${NavLink} {
        padding-right: 10px;
        padding-left: 0px;
        margin-right: 0;
        border-right: 2px solid ${colorBorder} !important;
        padding-top: 10px;
        padding-bottom: 10px;
        transition: background-color 0.3s;
        border-radius: 0;
        border: none;
        color: ${colorText};

        &:hover, &:focus, &:active {
          outline: none;
          background-color: ${colorHover};
        }
      }

      ${NavLink}.active, ${NavLink}.active:focus,
      ${NavLink}.active:hover {
        background-color: transparent !important;
        border-right-color: ${colorAccent} !important;
      }

      &.disabled ${NavLink} {
        color: #999999;
      }
    }
  }

  .tab-pane {
    padding-top: 0;
    padding-left: 20px;
  }
`;
export const VerticalColoredTabs = styled(VerticalTabs)`
  .nav-tabs ${NavItem} {
    ${NavLink} {
      border-right-color: ${colorBorder} !important;
      padding-left: 10px;
      text-align: center;
    }

    ${NavLink}.active, ${NavLink}.active:focus,
    ${NavLink}.active:hover {
      background-color: ${colorHover} !important;
      border-right-color: ${colorAccent} !important;
      color: ${colorAccent} !important;
    }
  }
`;